import { Flex, FlexProps, Image, Link } from '@chakra-ui/react';
import { MouseEvent } from 'react';
import { trackEvent } from '~/core/utils/trackEvent';
import { getWebLinkFaviconImg } from '~/screens/ManageWebLinks';
import { getDomainName } from '~/utils';

interface WebLinksProps extends FlexProps {
  links: string[];
  size?: number;
}

const handleClick = (e: MouseEvent, url: string) => {
  e.stopPropagation();

  trackEvent('foam-web-links-clicked', {
    link: url,
    type: getDomainName(url),
  });
};

const WebLinks: React.FC<WebLinksProps> = ({ links, size = 4, ...props }) => {
  if (!links || links.length === 0) return null;

  return (
    <Flex
      marginLeft={0.5}
      justify="wrap"
      alignItems="flex-start"
      gap={3.5}
      track-id="foam-web-links-container"
      {...props}
    >
      {links.map((linkItem, index) => (
        <Link
          key={`${index}-${linkItem}`}
          href={linkItem}
          target="_blank"
          onClick={(e: MouseEvent) => handleClick(e, linkItem)}
          track-id="foam-web-links-link"
        >
          <Image
            height={size}
            width={size}
            maxWidth={size}
            borderRadius={2}
            src={getWebLinkFaviconImg(linkItem)}
          />
        </Link>
      ))}
    </Flex>
  );
};

export default WebLinks;
